import {AccountType, MetaData} from "@qid/core";
import {DigilockerAuthResponse} from "./digilocker-auth-response.model";
import {RequestedDoc} from "./requested-doc.model";
import {DigilockerRequestStepModel} from "./digilocker-request-step.model";

export class DigilockerRequest extends MetaData {

  account_id: string
  accountType: AccountType;
  codeVerifier: string
  requestedDoc : RequestedDoc;
  authResponse: DigilockerAuthResponse;
  status: string;
  progressSteps: DigilockerRequestStepModel[];
  errorCode: string;
  errorMessage: string;
}


